export function dateFilter(value, separator) {
  if (!value) return '';
  if (separator === undefined || separator === null) separator = '-';

  value = (`${value}`).replace(/[^0-9]/g, '');
  value = value.replace(/^([0-9]{4})([0-9]{2})([0-9]{2}).*$/, '$1'+separator+'$2'+separator+'$3');
  return value;
}

export function dateTimeFilter(value, separatorD, separatorT) {
  if (!value) return '';

  value = (`${value}`).replace(/[^0-9]/g, '');
  if (separatorD === undefined || separatorD === null) separatorD = '-';
  if (separatorT === undefined || separatorT === null) separatorT = ':';

  value = value.replace(
    /^([0-9]{4})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2}).*$/,
    '$1'+separatorD+'$2'+separatorD+'$3 $4'+separatorT+'$5'+separatorT+'$6'
  );
  return value;
}

export function cellPhoneFilter(value) {
  if (!value) return '';

  value = (`${value}`).replace(/[^0-9]/g, '');
  value = value.replace(/^(02.{0}|[0-9]{3})?([0-9]{3,4})([0-9]{4}$)/, '$1-$2-$3').replace(/^-/, '');
  return value;
}
